import { render, staticRenderFns } from "./Station.vue?vue&type=template&id=127e3169&scoped=true"
import script from "./Station.vue?vue&type=script&lang=js"
export * from "./Station.vue?vue&type=script&lang=js"
import style0 from "./Station.vue?vue&type=style&index=0&id=127e3169&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127e3169",
  null
  
)

export default component.exports